
export function request(data) {
    return {
        type: 'CREATE_RELATED_CONTINGENCY_REQUEST',
        data
    };
}

export function error(errors) {
    return {
        type: 'CREATE_RELATED_CONTINGENCY_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'CREATE_RELATED_CONTINGENCY_FINISH',
        data
    };
}
